import { purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const PERSIST_KEY = 'codeevent-persist';

export const PERSIST_CONFIG = {
  key: PERSIST_KEY,
  storage,
  whitelist: ['solution'],
};

export function purgeReduxPersistance() {
  purgeStoredState(PERSIST_CONFIG);
}
